webpackJsonp([35],{

/***/ 194:
/***/ (function(module, exports) {

module.exports = {
	"about.contact": "Contact Host",
	"about.title": "About the host",
	"accounts.tabs.dashboard": "Dashboard",
	"accounts.tabs.reports": "Reports",
	"add-ons.active": "Active",
	"add-ons.all": "All",
	"add-ons.backToInventory": "Back to inventory",
	"add-ons.createPageTitle": "Create an add-on",
	"add-ons.description": "Offer additional items to your ticket buyers during checkout that can be picked up or redeemed at your event.",
	"add-ons.editPageTitle": "Edit your add-on",
	"add-ons.empty-addons": "You can start selling add-ons to your events and be able to track the inventory. Get started now",
	"add-ons.empty-addons-state": "Hmm, it doesn’t look like any add-ons match your filters",
	"add-ons.empty-events": "Oops! You'll need to create an event first before you can create an add-on.",
	"add-ons.errorFlashMessage": "Oops! Something went wrong. Please try again.",
	"add-ons.free": "Free",
	"add-ons.htmlTitle": "Add-ons - Universe",
	"add-ons.inactive": "Inactive",
	"add-ons.orders": "Orders",
	"add-ons.orders.actions": "Actions",
	"add-ons.orders.add-ons": "Add-on",
	"add-ons.orders.all-days": "All Days",
	"add-ons.orders.all-statuses": "All Statuses",
	"add-ons.orders.attendee": "Attendee",
	"add-ons.orders.buyer": "Buyer",
	"add-ons.orders.cancelled": "Cancelled",
	"add-ons.orders.check-in-state": "Status",
	"add-ons.orders.checked-in": "Redeemed",
	"add-ons.orders.checked-out": "Not redeemed",
	"add-ons.orders.date": "Date",
	"add-ons.orders.email": "Email",
	"add-ons.orders.empty": "Sorry! There are no orders matching the filters you've chosen",
	"add-ons.orders.event-name": "Event Name",
	"add-ons.orders.message-buyer": "Message Buyer",
	"add-ons.orders.name": "Name",
	"add-ons.orders.not-redemeed": "Not redeemed",
	"add-ons.orders.past-30-days": "Past 30 Days",
	"add-ons.orders.past-7-days": "Past 7 Days",
	"add-ons.orders.redeemed": "Redeemed",
	"add-ons.orders.refund-cancel": "Refund & Cancel",
	"add-ons.orders.refund-order": "Refund Order",
	"add-ons.orders.refund-title": "Refund and cancel add-ons",
	"add-ons.orders.refund-undo": "This action cannot be undone",
	"add-ons.orders.sales": "Sales",
	"add-ons.orders.search-buyers": "Search Buyers",
	"add-ons.orders.view-order": "View Order",
	"add-ons.sold-out": "Sold out",
	"add-ons.table.are-you-sure": "Are you sure you want to delete this add-on?",
	"add-ons.table.create-add-on": "Create add-on",
	"add-ons.table.create-event": "Create an event",
	"add-ons.table.header.actions": "Action",
	"add-ons.table.header.active": "Active",
	"add-ons.table.header.applies-to": "Applies to",
	"add-ons.table.header.availability": "Available",
	"add-ons.table.header.name": "Add-ons",
	"add-ons.table.header.options": "Options",
	"add-ons.table.header.price": "Price",
	"add-ons.table.row.all-events": "All {currencyCode} events",
	"add-ons.table.row.all-or-some-events": "{listingsCountText} {currencyCode} events",
	"add-ons.title": "Add-ons",
	"add-ons.unlimited": "Unlimited",
	"additional-images.title.one": "photo",
	"additional-images.title.other": "photos",
	"addons.absorbFees": "Absorb into the price",
	"addons.addNewTax": "Add a new tax",
	"addons.addOnDescriptionLengthErrorMessage": "Add-on description must be less than 400 characters",
	"addons.addOnDetailsSubheading": "Please include taxes in the add-on price.",
	"addons.addOnName": "What is your add-on called?",
	"addons.addOnNameBlankErrorMessage": "Add-on name is required",
	"addons.addOnNameErrorMessage": "Add-on name is required",
	"addons.addOnNameLengthErrorMessage": "Add-on name must be less than 95 characters",
	"addons.addOnNamePlaceholder": "Add-on name",
	"addons.addOption": "Add Option",
	"addons.addTax": "Add tax",
	"addons.basicInformation": "Basic Information",
	"addons.cancel": "Cancel",
	"addons.capacityAvailabilityInput": "Quantity Available",
	"addons.capacityInputPlaceholder": "Unlimited",
	"addons.createAddon": "Create add-on",
	"addons.customTaxSelection": "Create New Tax",
	"addons.describeAddOn": "How would you describe your add-on?",
	"addons.describeAddOnPlaceholder": "Tell buyers what they need to know about what you are selling. Keep it short and simple",
	"addons.describeAddOnSubheading": "This description will appear during checkout.",
	"addons.editEventsButton": "Edit events",
	"addons.errorFlashMessage": "Oops! Something went wrong. Please try again.",
	"addons.eventsCheckBox": "This add-on will be available on all events transacting in {currencyCode}",
	"addons.eventsSubtitle": "Make this add-on available for",
	"addons.eventsTitle": "Events Selector",
	"addons.feeMessage": "Set who pays the Universe Service Fee.",
	"addons.feeSelectDisabled": "This feature has been disabled by a sales representative for tax reasons. Please contact them if you have any questions or concerns.",
	"addons.fees": "Fees",
	"addons.maxQuantityInput": "Max per order",
	"addons.minQuantityInput": "Min per order",
	"addons.nameInput": "Option",
	"addons.nameInputPlaceholder": "Ex. Small",
	"addons.optionNamesErrorMessage": "An option name is required",
	"addons.optionUsedErrorMessage": "Option cannot be removed because it has sold add-ons",
	"addons.passFeesToBuyer": "Pass fees to the buyer",
	"addons.photo": "Add-on photo",
	"addons.priceInput": "Price",
	"addons.priceInputErrorMessage": "Price is required",
	"addons.priceInputPlaceholder": "Free",
	"addons.printedTicketCharactersDisplayingLimit": "For printed tickets we will only be able to display 15 characters.",
	"addons.save": "Save",
	"addons.saveAsDraft": "Save as draft",
	"addons.selectCurrency": "I am selling my add-on in",
	"addons.selectTax": "Select Tax...",
	"addons.skuInput": "SKU",
	"addons.skuInputPlaceholder": "SKU or product number",
	"addons.taxMessage": "You are responsible for all local tax laws. Universe does not withhold or remit taxes collected on your behalf.",
	"addons.taxNameInput": "Tax name",
	"addons.taxNameInputPlaceholder": "Ex. GST",
	"addons.taxPercentInput": "Rate",
	"addons.taxPercentInputPlaceholder": "Ex. 5",
	"addons.taxRegNumInput": "Tax registration number",
	"addons.taxes": "Taxes",
	"addons.title": "Create an add-on",
	"addons.uploadBody": "(min 100 x 100 px, max 2mb)",
	"addons.uploadHeader": "Add photo",
	"balance.balanceCardTooltip": "In order to withdraw your funds you need to have at least $10.00 available in your account.",
	"balance.balancesTitle": "Balances",
	"balance.description": "All funds will be added to your Universe account balance from 48 hours after the end of your event.",
	"balance.manageEditEventLink": "Manage / Edit My Event",
	"balance.messagesLink": "Messages",
	"balance.paymentPreferencesLink": "Payment Preferences",
	"balance.quickLinksTitle": "Quick Links",
	"balance.requestFunds": "Request your funds",
	"balance.requested.empty": "You have no withdrawals.",
	"balance.requested.header.amountRequested": "Amount requested",
	"balance.requested.header.date": "Date",
	"balance.requested.header.sentTo": "Sent to",
	"balance.requested.header.status": "Status",
	"balance.requestedFundsTitle": "Requested funds",
	"balance.requestedFundsInfo": "Didn't receive an email to activate your Payouts Account?",
	"balance.chargebacks-access-payouts": "Access Universe Payouts",
	"balance.chargebacksTitle": "Chargeback Activity",
	"balance.chargebacks-title": "Why do I have a chargeback on my account?",
	"balance.chargebacks-learn-more": "Learn more",
	"balance.status.approved": "Approved",
	"balance.status.approvedTooltip": "The funds requested have been sent to your Universe Payouts account for you to transfer.",
	"balance.status.failed": "Failed",
	"balance.status.failedTooltip": "Your request could not be processed. Please try again or contact us for assistance.",
	"balance.status.underReview": "Under review",
	"balance.status.underReviewTooltip": "Requests are typically under review for 1 - 2 business days. Once approved, you'll receive an email with next steps.",
	"balance.title": "My {currency} Balances",
	"balance.totalBalanceTitle": "Total balance",
	"balance.totalBalanceTooltip": "These funds are available to request from your account. A minimum of {formattedAmount} is required.",
	"balance.universePayoutsLink": "Universe Payouts",
	"balance.upcomingFundsTitle": "Upcoming funds",
	"balance.upcomingFundsTooltip": "Funds from events that are currently selling tickets or have ended within 48 hours. Funds will become available to request from 48 hours after the end of your event.",
	"balance.usersAndPermissionsLink": "Users and Permissions",
	"basics.categoryError": "Category is required",
	"basics.coverUploadBody": "(min 1110 x 444 px, max 5mb, avoid including any text on the photo)",
	"basics.coverUploadHeader": "Add event page cover image",
	"basics.describeEvent": "Describe your event",
	"basics.describeEventPlaceholder": "What's your event about, who is it for, what makes it unique?",
	"basics.descriptionError": "Description is required",
	"basics.eventName": "What is your event name?",
	"basics.eventNameError": "Event name is required",
	"basics.eventNamePlaceholder": "Make it short and catchy",
	"basics.selectCategory": "Select a category for your event",
	"basics.selectCategoryDropDownTitle": "Select category",
	"basics.selectCategoryTip": "This will help others find your event",
	"basics.selectCurrencyTitle": "Select currency",
	"basics.socialUploadBody": "(min 100 x 100 px, max 2mb)",
	"basics.socialUploadHeader": "Add social media photo",
	"basics.title": "Tell the world about your event",
	"basics.whenAndWhereButton": "When and where",
	"beta-dashboard.currency.all-events-paid-in": "All events paid in {currency}",
	"beta-dashboard.past-seven-days": "Past 7 days",
	"beta-dashboard.past-thirty-days": "Past 30 days",
	"beta-dashboard.timeline.no-host-msg": "A timeline of all your event net sales will be populated once you have made your first sale!",
	"beta-dashboard.timeline.no-revenue-msg": "There is currently no revenue made during the selected date range. Try filtering to a different date range to see sales.",
	"beta-dashboard.timeline.title": "Revenue timeline",
	"beta-dashboard.timeline.tooltip": "Only events with revenue during the selected date range will be shown below",
	"beta-dashboard.title": "Account overview",
	"buybutton.from-price": "from",
	"buybutton.get-tickets.donate": "Donate",
	"buybutton.get-tickets.get_tickets": "Get Tickets",
	"buybutton.get-tickets.register": "Register",
	"buybutton.get-tickets.rsvp": "RSVP",
	"buybutton.get-tickets.undefined": "Get Tickets",
	"buybutton.price": "Price",
	"buybutton.price-expired": "Request a new event",
	"buybutton.price-free": "Free",
	"buybutton.report": "Report Event",
	"buybutton.save": "save",
	"buybutton.saved": "saved",
	"buybutton.share": "Share",
	"components.buy-button.virtualEvent": "Virtual event",
	"components.my-tickets.orderProtectDescription": "Order Protection provided by Booking Protect.",
	"components.my-tickets.virtualEvent": "Virtual event",
	"components.my-tickets.virtualEventDescription": "Details on how to join will be emailed to you 1 hour before the event.",
	"components.title.virtualEvent": "Virtual event",
	"contact.addDetails": "+ Add contact details",
	"contact.label": "Contact details",
	"contact.placeholder": "Enter an email address or phone number",
	"contact.subLabel": "Your contact information is kept private and shown only to attendees who book a ticket.",
	"coverphoto.edit": "Event Manager",
	"create.progress.basics": "BASICS",
	"create.progress.tickets": "TICKETS",
	"create.progress.whenAndWhere": "WHEN & WHERE",
	"create.progress.whenAndWhereDesktop": "WHEN AND WHERE",
	"customReports.createCustomReport": "Create a custom report",
	"customReports.download": "Download",
	"dashboard.SalesChannels": "Top referrals",
	"dashboard.allevents": "Show all",
	"dashboard.apply": "Apply",
	"dashboard.balances.empty.desc": "You have no balances to withdraw.",
	"dashboard.balances.title": "Balances",
	"dashboard.banner": "We are investigating data latency on the account dashboard: {link}. Please use this legacy dashboard in the meantime until the latency incident has been resolved.",
	"dashboard.buyersDemographics": "Buyers' demographics",
	"dashboard.buyersLocation": "Location",
	"dashboard.channels": "Channels",
	"dashboard.confirm": "Confirm",
	"dashboard.currency.all-events-paid-in": "{currency} events",
	"dashboard.custom": "Custom Date",
	"dashboard.custom-events.cancel": "Cancel",
	"dashboard.custom-events.currency-select": "{currency} events",
	"dashboard.custom-events.date": "Date",
	"dashboard.custom-events.draft": "Draft",
	"dashboard.custom-events.empty-state-no-events": "Sorry! There's no events shown for the filters you've chosen.",
	"dashboard.custom-events.event-name": "Event name",
	"dashboard.custom-events.expired": "Expired",
	"dashboard.custom-events.filter-events": "{count, plural, one {Filter {count} event} other {Filter {count} events}}",
	"dashboard.custom-events.live": "Live",
	"dashboard.custom-events.num-selected-events": "{count, number} selected",
	"dashboard.custom-events.scheduled-publish": "Scheduled publish: {formattedDate}",
	"dashboard.custom-events.seatingMapMustBeCreatedToPublish": "Seating map must be created to publish",
	"dashboard.custom-events.select-all-events": "Select all events",
	"dashboard.custom-events.status": "Status",
	"dashboard.custom-events.title": "Filter events",
	"dashboard.errorBuyerDemographicsNoData": "Sorry! There’s no demographics information for the filters you’ve chosen.",
	"dashboard.errorBuyerDemographicsNoHost": "You’ll soon be able to see the age ranges and genders of your buyers once you start selling tickets",
	"dashboard.errorBuyerLocationsNoData": "Sorry! There’s no location information for the filters you’ve chosen.",
	"dashboard.errorBuyerLocationsNoHost": "You’ll soon be able to see the top purchasing locations for your events once you start selling tickets",
	"dashboard.errorSalesChannelsNoData": "Sorry! There’s no referral information for the filters you’ve chosen.",
	"dashboard.errorSalesChannelsNoHost": "You’ll soon be able to see the top referrals for your events once you start selling tickets",
	"dashboard.femaleBuyer": "Female",
	"dashboard.filter_custom_dates": "Filter custom dates",
	"dashboard.filterbar.reports.cost_items": "Tickets Report",
	"dashboard.filterbar.reports.default": "Default",
	"dashboard.filterbar.reports.events": "Ticket Type Summary - Date/Time Level",
	"dashboard.filterbar.reports.listings": "Ticket Type Summary - Event Level",
	"dashboard.filterbar.reports.orders": "Sales Report",
	"dashboard.filterbar.reports.placeholder": "Reports",
	"dashboard.filterbar.reports.timerange.all": "All Transactions",
	"dashboard.filterbar.reports.timerange.cancel": "Cancel",
	"dashboard.filterbar.reports.timerange.custom": "Custom Date Range",
	"dashboard.filterbar.reports.timerange.download": "Download Report",
	"dashboard.filterbar.reports.timerange.mtd": "Past 30 Days",
	"dashboard.filterbar.reports.timerange.single": "Single Day",
	"dashboard.filterbar.reports.title": "Select a date range for your {reportTitle}",
	"dashboard.free": "Free",
	"dashboard.insights.averageOrderPrice": "average order price",
	"dashboard.insights.averageTicketCountPerOrder": "tickets per order",
	"dashboard.insights.averageTicketPrice": "average ticket price",
	"dashboard.insights.popularTimeOfPurchase": "popular time of purchase",
	"dashboard.insights.title": "Insights",
	"dashboard.liveevents.create-new": "Create a New Event",
	"dashboard.liveevents.event-date-and-more": "{formattedDate} + {moreTimeSlotCount, number} more",
	"dashboard.liveevents.no-events": "You don't have any live events yet!",
	"dashboard.liveevents.title": "My live events",
	"dashboard.liveevents.viewall": "View All Events",
	"dashboard.mainBuyersAgeRange": "Main age range",
	"dashboard.maleBuyer": "Male",
	"dashboard.mobile-custom-events.filter-events": "Filter events",
	"dashboard.mobile-custom-events.num-selected-events": "{count, number} selected",
	"dashboard.mobile-custom-events.show-all": "Show all",
	"dashboard.mobile-custom-events.show-all-events": "Show all events",
	"dashboard.orders": "Orders",
	"dashboard.orders-with-value": "Orders: {value}",
	"dashboard.organizationSelect.organization": "Organization",
	"dashboard.organizationSelect.switch": "Switch dashboard",
	"dashboard.organizationSelect.yourDashboard": "Your Dashboard",
	"dashboard.past-seven-days": "Past 7 days",
	"dashboard.past-thirty-days": "Past 30 days",
	"dashboard.quicklinks.manage": "Manage / Edit My Events",
	"dashboard.quicklinks.mymessages": "My Messages",
	"dashboard.quicklinks.organizations": "Users and Permissions",
	"dashboard.quicklinks.paymentprefs": "Payment Preferences",
	"dashboard.quicklinks.title": "Quick links",
	"dashboard.revenue.title": "Revenue",
	"dashboard.revenue.tooltip": "Revenue includes your ticket sales with any taxes and additional fees you've collected and does not include any discounts, Universe fees or commissions",
	"dashboard.sales": "Sales",
	"dashboard.sales-with-value": "Sales: {value}",
	"dashboard.salesChannels": "Top channels",
	"dashboard.salesChannelsNoHost": "Top channels",
	"dashboard.showallevents": "Show all events",
	"dashboard.tickets-breakdown.available": "Available",
	"dashboard.tickets-breakdown.empty": "You'll be able to see your events and ticket types sold out rate once your events are live.",
	"dashboard.tickets-breakdown.event": "Event",
	"dashboard.tickets-breakdown.net-sales": "Net sales",
	"dashboard.tickets-breakdown.sold-out-rate": "Sold out rate",
	"dashboard.tickets-breakdown.tickets-sold": "Sold",
	"dashboard.tickets-breakdown.title": "Tickets breakdown",
	"dashboard.tickets-breakdown.tooltip": "The tickets breakdown shows upcoming published events and only the total available tickets across all timeslots.",
	"dashboard.tickets-breakdown.unlimited-quantity": "—",
	"dashboard.ticketssold": "Tickets sold",
	"dashboard.timeline.empty.publish.desc": "A timeline of all your event net sales will show here once an event is published.",
	"dashboard.timeline.empty.publish.title": "Publish an Event",
	"dashboard.timeline.empty.selling.desc": "A timeline of all your event net sales will show here once you've started selling tickets.",
	"dashboard.timeline.empty.selling.title": "Start Selling Tickets",
	"dashboard.timeline.monthof": "Month Of",
	"dashboard.timeline.start-selling-tickets": "Start selling tickets",
	"dashboard.timeline.title": "Sales Timeline for All Events",
	"dashboard.timeline.weekof": "Week Of",
	"dashboard.title": "Account overview",
	"dashboard.topBuyersLocations": "Top locations",
	"dashboard.uniqueBuyers": "Unique buyers",
	"dashboard.upgradeaccount.changeplan": "Change Plan",
	"dashboard.upgradeaccount.description": "Access more sales channels, team permissions, and priority support.",
	"dashboard.upgradeaccount.title": "Upgrade your account",
	"dashboard.year-to-date": "Year to date",
	"date-and-time.more": "+{numValues} More",
	"date-and-time.title": "Date and time",
	"description.less": "- Less",
	"description.more": "+ More",
	"event-time.date_time": "{dateRange} at {timeRange}",
	"gdc.configure.codes": "Configure Discount Codes",
	"gdc.delete.are-you-sure": "Are you sure you want to delete all unused global discount codes? Codes already redeemed will not have their discounts removed.",
	"gdc.delete.are-you-sure-single": "Are you sure you want to delete this global discount code? Note: any code that has been redeemed can not be deleted.",
	"gdc.delete.cancel": "Cancel",
	"gdc.delete.cannot-be-undone": "Deletion is final and cannot be undone.",
	"gdc.delete.code-used": "This discount code cannot be deleted because it has already been used.",
	"gdc.delete.delete": "Delete",
	"gdc.delete.title": "Confirm delete",
	"gdc.discount.fixed": "Fixed amount",
	"gdc.discount.percent": "Percent",
	"gdc.error.code.blank": "Code cannot be blank",
	"gdc.error.code.invalid": "Invalid code",
	"gdc.error.code.taken": "Discount code name is already in use",
	"gdc.error.quantity.negative": "Quantity cannot be negative",
	"gdc.error.value.blank": "Value cannot be blank",
	"gdc.error.value.large": "Value too large",
	"gdc.error.value.small": "Value too small",
	"gdc.export.exportToCSV": "Export to CSV",
	"gdc.htmlTitle": "Global Discount Codes - Universe",
	"gdc.import.cancel": "Cancel",
	"gdc.import.codesFailedUpload": "All codes have failed to upload",
	"gdc.import.codesSuccessfullyUploaded": "{numOfSuccesses} codes uploaded successfully",
	"gdc.import.conditionalSuccessfulUpload": "Successfully uploaded {numOfSuccesses} codes. {numOfErrors} duplicates were removed",
	"gdc.import.csv": "Import from CSV",
	"gdc.import.errorFlashMessage": "The .csv selected contains more than the maximum of 1000 codes per upload.",
	"gdc.import.eventsAndTickets": "All events and tickets",
	"gdc.import.headerRowExists": "CSV contains a header row?",
	"gdc.import.moreThanOneErrorAndOneSuccess": "Successfully uploaded 1 code. {numOfErrors} duplicates were removed",
	"gdc.import.numberOfCodes": "Number of codes available",
	"gdc.import.oneAndOneUpload": "Successfully uploaded 1 code. 1 duplicate was removed",
	"gdc.import.oneErrorAndMultipleSuccess": "Successfully uploaded {numOfSuccesses} codes. 1 duplicate was removed",
	"gdc.import.smallText": "Processing time increases depending on the number of codes.",
	"gdc.import.subheader": "All {numOfCodes} codes will be applied with these settings. Duplicates will be ignored.",
	"gdc.info.desc": "Global discount codes let you offer reduced pricing for all of your events. These codes apply to all of your events and tickets, including future events, and are separate from event discount codes.",
	"gdc.info.learn-more": "{link} about discount codes.",
	"gdc.row.all-events-and-tickets": "All events and tickets",
	"gdc.row.unlimited": "Unlimited",
	"gdc.search.noCodes": "Hmm, it doesn't look like any codes match your search",
	"gdc.search.searchCodes": "Search Codes",
	"gdc.table.add": "Add discount code",
	"gdc.table.applies-to": "Applies to",
	"gdc.table.code": "Code",
	"gdc.table.delete": "Delete",
	"gdc.table.deleteAll": "Delete All",
	"gdc.table.deletedAllCodes": "All unused codes deleted",
	"gdc.table.deletedCode": "Deleted code",
	"gdc.table.discount": "Discount",
	"gdc.table.empty": "You don't have any global discount codes.",
	"gdc.table.errorDelete": "Error: unable to delete",
	"gdc.table.errorMsgNoUnused": "No unused codes to delete",
	"gdc.table.errorMsgUnused": "Can only delete unused codes",
	"gdc.table.quantity": "Quantity",
	"gdc.table.save": "Save",
	"gdc.table.state": "State",
	"gdc.table.uses": "Uses",
	"gdc.title": "Global Discount Codes",
	"gdc.unlimited": "Unlimited",
	"gdc.upload.discounts": "Upload Discounts",
	"generate-invoice.create-error": "There was a problem creating your invoice",
	"generate-invoice.create-success": "Invoice created",
	"generate-invoice.form.address": "Address",
	"generate-invoice.form.city": "City",
	"generate-invoice.form.company": "Company",
	"generate-invoice.form.country": "Country",
	"generate-invoice.form.fullName": "Full name",
	"generate-invoice.form.generate-button": "Generate invoice",
	"generate-invoice.form.optional": "(Optional)",
	"generate-invoice.form.stateProvince": "State/Province",
	"generate-invoice.form.taxNumber": "Tax no",
	"generate-invoice.form.title": "Invoice",
	"generate-invoice.form.zipPostal": "Zip/Postal code",
	"generate-invoice.go-back": "< Go back",
	"generate-invoice.subheading": "The following information represents the details that will be used to generate your invoice. Please review your information carefully as once your invoice has been generated, this information cannot be changed.",
	"generate-invoice.title": "Generate invoice",
	"integrations.cancelButton": "Cancel",
	"integrations.description": "Add any of the following integrations to all your events in one step. You can override these integrations at the event level at any time. {learnMoreLink} about integrations.",
	"integrations.disabled": "disabled",
	"integrations.ecommerceTracking": "Ecommerce tracking",
	"integrations.enabled": "enabled",
	"integrations.gaCheckBox": "Enable Ecommerce tracking",
	"integrations.gaFormatError": "Google analytics id wrong format.",
	"integrations.gaIdTitle": "Google Analytics Id",
	"integrations.gaSubheading": "Send data to Google Analytics for advanced tracking. {learnMoreLink}",
	"integrations.gaTitle": "Google Analytics",
	"integrations.htmlTitle": "Integrations",
	"integrations.learnMore": "Learn more",
	"integrations.pageTitle": "Integrations",
	"integrations.saveButton": "Save",
	"interests.title": "Interests",
	"lines.addOnRevenue": "Add-ons revenue",
	"lines.addOnRevenueByEvent": "Add-on revenue by event",
	"lines.ticketRevenue": "Ticket revenue",
	"lines.ticketRevenueByEvent": "Ticket revenue by event",
	"lines.totalRevenue": "Total revenue",
	"lines.totalRevenueByEvent": "Total revenue by event",
	"listing.date": "Date",
	"listing.description.title": "Description",
	"listing.draft": "Draft",
	"listing.live": "Live",
	"listing.status": "Status",
	"listing.subtitleAllListingsApplied": "This add-on is available on all {currencyCode} listings",
	"listing.subtitleSelectedListings": "This add-on is available on the following listings",
	"listing.title": "Event Name",
	"listings.all": "All {currencyCode} events",
	"listings.createEvent": "Create event",
	"listings.editListings": "Add-on is currently applied to these events:",
	"listings.noLiveListings": "Oops! Looks like this add-on is not available on any upcoming events.",
	"listings.some": "Select {currencyCode} events",
	"location.get-directions": "Get Directions",
	"location.title": "Location",
	"menu.more": "More",
	"modal.bookingOrder.benefitBody": "Have the comfort of knowing if you miss your event, that you’re protected for the unfortunate and unexpected. The Order Protection solution covers:",
	"modal.bookingOrder.benefit_accident": "Accident",
	"modal.bookingOrder.benefit_duty": "Jury or military duty",
	"modal.bookingOrder.benefit_illness": "Illness",
	"modal.bookingOrder.benefit_service": "Emergency services",
	"modal.bookingOrder.benefit_transportation": "Cancelled transportation",
	"modal.bookingOrder.benefit_weather": "Extreme weather",
	"modal.bookingOrder.benefits": "Benefits",
	"modal.bookingOrder.cancellationRefunds": "Cancellations & Refunds",
	"modal.bookingOrder.cancellation_body": "Order Protection is non-refundable unless cancelled within 14 days of purchase and the event has not taken place. To cancel Order Protection you need to contact Universe within 14 days.",
	"modal.bookingOrder.findMoreInfo": "Find out more information about Order Protection {link}.",
	"modal.bookingOrder.header": "Order Protection",
	"modal.bookingOrder.refund": "Request a refund",
	"modal.bookingOrder.refund_body": "You must log into {link} and complete and submit the Refund Application Form as soon as possible after becoming aware of circumstances that may lead you to request a refund but no more than 45 days after the booked event.",
	"modal.bookingOrder.requestingRefund": "Requesting a refund",
	"modal.cancelOrder.body": "Are you sure you want to cancel this order? This will cancel all tickets in your order.",
	"modal.cancelOrder.body2": "This action cannot be undone.",
	"modal.cancelOrder.cancelButton": "Keep order",
	"modal.cancelOrder.confirmButton": "Cancel order",
	"modal.cancelOrder.header": "Confirm cancellation",
	"modal.cancelTicketTransfer.body": "Are you sure you want to cancel this transfer? Once cancelled, the link the recipient received to accept the ticket transfer will no longer be valid and the ticket will remain in your account.",
	"modal.cancelTicketTransfer.closeButton": "Close",
	"modal.cancelTicketTransfer.confirmButton": "Cancel transfer",
	"modal.cancelTicketTransfer.header": "Cancel transfer",
	"modal.changeOrderDate.body": "All tickets in this order will be moved to the new date.",
	"modal.changeOrderDate.confirmButton": "Confirm new date",
	"modal.changeOrderDate.currentDate": "Current date",
	"modal.changeOrderDate.gotItButton": "Got it",
	"modal.changeOrderDate.header": "Change date",
	"modal.changeOrderDate.newTime": "New time",
	"modal.changeOrderDate.selectTimeslot": "Select time",
	"modal.changeOrderDate.success": "You’ve successfully changed the date",
	"modal.changeOrderDate.successWhen": "New date for your order is {date}. New tickets will be emailed to {email}",
	"modal.confirmPayment.cancelButton": "Cancel",
	"modal.confirmPayment.confirmButton": "Confirm payment",
	"modal.confirmPayment.title": "Confirm payment",
	"modal.confirmPaymentr.body": "Please confirm you want to complete Payment {installmentNumber} now.",
	"modal.confirmPaymentr.installment": "Payment {installmentNumber}",
	"modal.confirmPayments.cancelButton": "Cancel",
	"modal.confirmPayments.confirmButton": "Confirm payment",
	"modal.confirmPayments.title": "Confirm payment",
	"modal.confirmPaymentsr.body": "Please confirm you want to pay your remaining balance now to complete your order.",
	"modal.confirmPaymentsr.remainingBalance": "Remaining Balance",
	"modal.duplicateEvent.duplicateButton": "Duplicate event",
	"modal.editBuyerInfo.header": "Edit buyer info",
	"modal.editGuestInfo.header": "Edit guest info",
	"modal.editInfo.cancelButton": "Cancel",
	"modal.editInfo.saveButton": "Save changes",
	"modal.generateInvoiceConfirmation.blank": "-",
	"modal.generateInvoiceConfirmation.body": "Before we generate your invoice please confirm that the information is correct. This information cannot be changed once your invoice has been generated.",
	"modal.generateInvoiceConfirmation.cancelButton": "Cancel",
	"modal.generateInvoiceConfirmation.confirmButton": "Confirm",
	"modal.generateInvoiceConfirmation.header": "Confirm invoice",
	"modal.generateShowInvoice.body": "Your invoice is now ready!",
	"modal.generateShowInvoice.goBackButton": "Back",
	"modal.generateShowInvoice.header": "Invoice created",
	"modal.generateShowInvoice.viewInvoice": "View Invoice",
	"modal.listing.event-disclosure.body-delivery": "All tickets are delivered electronically to the email address you enter at checkout, with no additional fee or service charge.",
	"modal.listing.event-disclosure.cancel": "Cancel",
	"modal.listing.event-disclosure.header": "Event disclosure information",
	"modal.listing.event-disclosure.multiple-timeslots": "Maximum capacity for all time slots is {totalAvailable}.",
	"modal.listing.event-disclosure.no-capacity": "There is no maximum capacity set this event.",
	"modal.listing.event-disclosure.single-timeslot": "Maximum capacity for this event is {totalAvailable}.",
	"modal.requestRefund.body": "Message the host directly to request a refund.",
	"modal.requestRefund.cancelButton": "Cancel",
	"modal.requestRefund.confirmButton": "Send message",
	"modal.requestRefund.header": "Request a refund",
	"modal.transferTicket.body": "You are transferring the ownership of this ticket. The recipient will be asked to accept the transfer. Once accepted:",
	"modal.transferTicket.bodyAddOn": "You are transferring the ownership of this add-on. The recipient will be asked to accept the transfer. Once accepted:",
	"modal.transferTicket.bullet1": "This transfer cannot be reversed.",
	"modal.transferTicket.bullet2": "This order will become non-refundable.",
	"modal.transferTicket.bullet3": "Only the new ticket owner will be able to change / transfer the ticket.",
	"modal.transferTicket.bullet3AddOn": "Only the new add-on owner will be able to change / transfer the add-on.",
	"modal.transferTicket.cancelButton": "Cancel",
	"modal.transferTicket.confirmButton": "Transfer ticket",
	"modal.transferTicket.confirmButtonAddOn": "Transfer add-on",
	"modal.transferTicket.gotItButtonText": "Got it",
	"modal.transferTicket.header": "Transfer your ticket",
	"modal.transferTicket.headerSuccess": "You transferred one ticket",
	"modal.transferTicket.headerSuccessAddOn": "You transferred one add-on",
	"modal.transferTicket.headerTransfer": "Transfer",
	"modal.transferTicket.optionName": "Option",
	"modal.transferTicket.ownerName": "Owner",
	"modal.transferTicket.ticketRequestSuccess": "A link to accept this ticket transfer has been sent to {email}",
	"modal.transferTicket.ticketRequestSuccessAddOn": "A link to accept this add-on transfer has been sent to {email}",
	"modal.transferTicket.transferRemainingAddOnsWarning": "You have add-ons left on this order",
	"modal.transferTicket.transferRemainingAddOnsWarningBody": "Please remember to transfer any add-ons to your guest(s) if necessary.",
	"modal.transferTicket.transferTicketWarning": "Do you also need to transfer a ticket?",
	"modal.transferTicket.transferTicketWarningBody": "Please ensure your add-on recipient also has a ticket as a ticket might be needed to redeem the add-on.",
	"modal.transferTicketDisabled.body": "{days, plural, one {The host of this event has disabled ticket transfers {days} day before the event. If you have any questions, please contact them directly.} other {The host of this event has disabled ticket transfers {days} days before the event. If you have any questions, please contact them directly.}}",
	"modal.transferTicketDisabled.body.never": "The host of this event has disabled ticket transfers. If you have any questions, please contact them directly.",
	"modal.transferTicketDisabled.contactButton": "Contact host",
	"modal.transferTicketDisabled.goBackButton": "Go back",
	"modal.transferTicketDisabled.header": "Ticket transferring disabled",
	"modal.transferTicketResend.body": "Are you sure you want to resend this transfer? Once resent, the initial link the recipient received to accept the ticket transfer will no longer be valid.",
	"modal.transferTicketResend.cancelButton": "Cancel",
	"modal.transferTicketResend.confirmButton": "Confirm",
	"modal.transferTicketResend.header": "Resend transfer",
	"modal.transferTicketResend.resendTransferTo": "Resend transfer to:",
	"modal.transferTicketResend.sentTransferTo": "Transfer was sent to:",
	"my-tickets.addOn": "Add-on",
	"my-tickets.cancelOrder": "Cancel order",
	"my-tickets.cancelOrderError": "Cancel order failed",
	"my-tickets.cancelOrderSuccess": "Order successfully canceled",
	"my-tickets.cancelTicketTransfer": "Cancel ticket transfer",
	"my-tickets.cancelTicketTransferButton": "Cancel transfer",
	"my-tickets.cancelTicketTransferError": "Sorry, something went wrong",
	"my-tickets.cancelTicketTransferSuccess": "Transfer Cancelled",
	"my-tickets.cancelTransferBannerSuccess": "Ticket transfer to {email} has been cancelled",
	"my-tickets.changeDate": "Change date",
	"my-tickets.contactHost": "Contact host",
	"my-tickets.creditsAvailable": "Credits available",
	"my-tickets.current.error": "Unable to fetch current tickets right now. Please try again later.",
	"my-tickets.disabled-ticket-options": "This ticket cannot be edited or transferred at this time.",
	"my-tickets.downloadInvoice": "Download invoice",
	"my-tickets.downloadReceipt": "Download receipt",
	"my-tickets.editAddOn": "Edit add-on info",
	"my-tickets.editBuyerInfo": "Edit buyer info",
	"my-tickets.editGuestInfo": "Edit guest info",
	"my-tickets.emptyState.button": "Discover more events",
	"my-tickets.emptyState.title.passes": "You don't have any passes for upcoming events",
	"my-tickets.emptyState.title.tickets": "You don't have any events coming up. Want to fix that?",
	"my-tickets.generateInvoice": "Generate invoice",
	"my-tickets.inputLabel.email": "Email",
	"my-tickets.inputLabel.firstName": "First name",
	"my-tickets.inputLabel.lastName": "Last name",
	"my-tickets.installments": "Payments",
	"my-tickets.learn-more": "Learn More",
	"my-tickets.name": "Name",
	"my-tickets.optionColumn": "Option",
	"my-tickets.orderProtectDescription": "Order Protection provided by Booking Protect.",
	"my-tickets.passes-redeem": "Redeem",
	"my-tickets.passes.hide-events": "Hide Events",
	"my-tickets.passes.show-events": "Show Events",
	"my-tickets.past.error": "Unable to fetch past tickets right now. Please try again later.",
	"my-tickets.pastEvents": "Past Events",
	"my-tickets.refundError": "Message failed",
	"my-tickets.refundSuccess": "Message sent",
	"my-tickets.requestRefund": "Request refund",
	"my-tickets.resendTicketTransferButton": "Resend transfer",
	"my-tickets.resendTicketTransferError": "Sorry, something went wrong",
	"my-tickets.resendTicketTransferSuccess": "Transfer link resent",
	"my-tickets.resendTransferBannerSuccess": "Ticket transfer has been resent to {email}",
	"my-tickets.resendTransferTicket": "Resend transfer link",
	"my-tickets.seatsBooth": "Booth",
	"my-tickets.seatsGeneralAdmission": "General Admission",
	"my-tickets.seatsRow": "Row",
	"my-tickets.seatsSeat": "Seat",
	"my-tickets.seatsSeating": "Seating",
	"my-tickets.seatsSection": "Section",
	"my-tickets.seatsTable": "Table",
	"my-tickets.showLess": "Show less",
	"my-tickets.showMore": "Show more",
	"my-tickets.status": "Status",
	"my-tickets.subheading-1": "Get all the details on your Universe events and manage your tickets.",
	"my-tickets.subheading-2": "You can also review orders, check payment plans, transfer tickets, and more.",
	"my-tickets.submitClaim": "Request a refund",
	"my-tickets.ticket-state-attended": "Attended",
	"my-tickets.ticket-state-cancelled": "Cancelled",
	"my-tickets.ticket-state-declined": "Declined",
	"my-tickets.ticket-state-disputed": "Disputed",
	"my-tickets.ticket-state-ended": "Ended",
	"my-tickets.ticket-state-error": "Error",
	"my-tickets.ticket-state-failed": "Failed",
	"my-tickets.ticket-state-paid": "Paid",
	"my-tickets.ticket-state-partiallyPaid": "Partially Paid",
	"my-tickets.ticket-state-pendingTransfer": "Pending Transfer",
	"my-tickets.ticket-state-reserved": "Reserved",
	"my-tickets.ticket-state-transferred": "Transferred",
	"my-tickets.ticket-state-unapproved": "Unapproved",
	"my-tickets.ticket-state-unauthorized": "Unauthorized",
	"my-tickets.ticket-state-unpaid": "Unpaid",
	"my-tickets.ticket-state-upgraded": "Upgraded",
	"my-tickets.ticket-state-waitingForPayment": "Waiting for payment",
	"my-tickets.ticketTransferRecipient": "Ticket transfer recipient",
	"my-tickets.ticketType": "Ticket type",
	"my-tickets.ticketsError": "We couldn't load your tickets. Please reload the page or contact the support team if the issue persists.",
	"my-tickets.transferAddOn": "Transfer add-on",
	"my-tickets.transferTicket": "Transfer ticket",
	"my-tickets.transferTicket.modal.email-error": "Please enter a valid email address.",
	"my-tickets.transferTicketBannerSuccess": "A link to accept this ticket transfer has been sent to {email}",
	"my-tickets.transferTicketError": "Ticket transfer failed",
	"my-tickets.transferTicketSuccess": "Ticket transfer request has been sent",
	"my-tickets.upcomingEvents": "Upcoming Events",
	"my-tickets.updateBuyerInfoError": "Update Failed",
	"my-tickets.updateBuyerInfoSuccess": "Buyer Info Saved",
	"my-tickets.updateGuestInfoError": "Update Failed",
	"my-tickets.updateGuestInfoSuccess": "Guest Info Saved",
	"my-tickets.viewAddOn": "View add-on",
	"my-tickets.viewOrder": "View order",
	"my-tickets.viewPaymentPlan": "View Payment Plan",
	"my-tickets.viewTicket": "View ticket",
	"my-tickets.virtualEvent": "Virtual Event",
	"my-tickets.yourPasses": "My Passes",
	"my-tickets.yourTickets": "My Tickets",
	"myEvents.deletedListingSuccess": "{title} was successfully deleted.",
	"myEvents.draft": "Draft",
	"myEvents.duplicateEvent.accessKeys": "Access Keys",
	"myEvents.duplicateEvent.cancelButton": "Cancel",
	"myEvents.duplicateEvent.dateEndText": "End",
	"myEvents.duplicateEvent.dateError": "Start date must be before end date",
	"myEvents.duplicateEvent.dateStartText": "Start",
	"myEvents.duplicateEvent.discountCodes": "Discount Codes",
	"myEvents.duplicateEvent.duplicateButton": "Duplicate event",
	"myEvents.duplicateEvent.header": "Duplicate your event",
	"myEvents.duplicateEvent.selectOptionsCopy": "Please select if you would like to duplicate the following:",
	"myEvents.duplicateEvent.subheader": "Your duplicated event will include all of the same event settings and can be edited at any time.",
	"myEvents.duplicateEvent.title": "Title",
	"myEvents.duplicateEvent.titleError": "Event title must be less than 75 characters",
	"myEvents.event.delete": "Delete event",
	"myEvents.event.deleteSuccess": "Your event is deleted.",
	"myEvents.event.duplicate": "Duplicate event",
	"myEvents.event.manage": "Manage",
	"myEvents.event.message": "Message attendees",
	"myEvents.event.publish": "Publish event",
	"myEvents.event.publishSuccess": "Your event is now live.",
	"myEvents.event.reports": "Download reports",
	"myEvents.event.view": "View event page",
	"myEvents.event.viewSeatingMap": "View seating map",
	"myEvents.expired": "Expired",
	"myEvents.live": "Live",
	"myEvents.organization.myAccount": "My Account",
	"myEvents.recentEvents.lastUpdated": "Last updated: {formattedDate}",
	"myEvents.recentEvents.title": "Recently updated",
	"myEvents.search.placeholder": "Search all events by name",
	"myEvents.showAll": "Show all",
	"myEvents.title": "My Events",
	"myevents.error-state.create-new": "Create Event",
	"myevents.error-state.no-draft-events": "You have no draft events. Events that are saved but not published will be listed here.",
	"myevents.error-state.no-events": "You have no events. Get started now and make your next event the best one yet.",
	"myevents.error-state.no-expired-events": "You have no expired events. Completed events will show up here so you can review and keep track of them.",
	"myevents.error-state.no-live-events": "You have no live events. Once an event is published it will appear here.",
	"myevents.error-state.no-search-events": "Hmm, it doesn’t look like any events match your search.",
	"navbar.add-ons": "Add-ons",
	"navbar.balances": "Balances",
	"navbar.dashboard": "Dashboard",
	"navbar.description": "description",
	"navbar.global-discount-codes": "Discount Codes",
	"navbar.location": "location",
	"navbar.myEvents": "My Events",
	"navbar.photos": "photos",
	"navbar.reports": "Reports",
	"navbar.the-host": "the host",
	"page.not-found": "The page or event you were looking for went to the Land of Lost Things. We can {help} find it or take you {home}.",
	"page.not-found.credit": "Photography by {name}",
	"page.not-found.help": "help you",
	"page.not-found.home": "home",
	"payment-plan.amount": "Amount",
	"payment-plan.amountPaid": "Amount paid",
	"payment-plan.cancel": "Cancel",
	"payment-plan.cancelled": "This payment plan has been cancelled.",
	"payment-plan.congrats": "Congrats! You've paid this Payment Plan in full!",
	"payment-plan.dates": "Dates",
	"payment-plan.description": "Here is a summary of your Payment Plan. You can pay remaining balances and update your payment information.",
	"payment-plan.errors-intent-auth-failure": "We are unable to authenticate your payment method. Please choose a different payment method and try again.",
	"payment-plan.finePrint": "You hereby authorize Universe to continue to automatically charge you the installment amount on the defined milestone dates until the remaining balance is paid or you cancel your payment plan. The one-time Payment Plan fee is non-refundable.",
	"payment-plan.formFinePrint": "You hereby authorize Universe to continue to automatically charge you the installment amount on the defined milestone dates  until the remaining balance is paid. The one-time Payment Plan fee is non-refundable.",
	"payment-plan.installment": "Payment",
	"payment-plan.installment-status.cancelled": "Cancelled",
	"payment-plan.installment-status.failed": "Failed",
	"payment-plan.installment-status.paid": "Paid",
	"payment-plan.installment-status.refunded": "Refunded",
	"payment-plan.installment-status.unpaid": "Unpaid",
	"payment-plan.milestone": "Date",
	"payment-plan.nonThreeDSecureCardError": "This type of card is not supported. Please try again with a card that supports strong customer authentication (e.g. 3D Secure).",
	"payment-plan.pay": "Pay",
	"payment-plan.payInstallment": "Pay now",
	"payment-plan.payInstallmentError": "There was a problem processing your payment. Please verify your credit card details and try again.",
	"payment-plan.payInstallmentSuccess": "Payment processed successfully",
	"payment-plan.payRemainingBalance": "Pay remaining balance",
	"payment-plan.payingWith": "You are paying this plan with",
	"payment-plan.remainingBalanceTitle": "Remaining Balance:",
	"payment-plan.retry": "Retry payment",
	"payment-plan.retry-mobile": "Retry",
	"payment-plan.status": "Status",
	"payment-plan.tableTitle": "Payment Plan summary",
	"payment-plan.tooltip": "Price includes one-time Universe Payment Plan fee",
	"payment-plan.total": "Total",
	"payment-plan.update": "Update",
	"payment-plan.updateCreditCardDeclinedError": "Your card was declined. Please try again with a different card.",
	"payment-plan.updateCreditCardError": "Error, please retry",
	"payment-plan.updateCreditCardSuccess": "Successfully updated your credit card",
	"payment-plan.updateDetails": "Update details",
	"payment-plan.updatePayment": "Update payment",
	"payment-plan.yourPlan": "Your Payment Plan",
	"payment-plans.goBack": "< Go back",
	"profile.add-widget": "Learn how to add it to your website",
	"profile.change-avatar": "Change avatar",
	"profile.change-cover-photo": "Change cover photo",
	"profile.discover-events": "Discover other events",
	"profile.edit": "Edit profile",
	"profile.event-sold-out": "Sold out",
	"profile.events": "Events",
	"profile.events-by": "Events by {name}",
	"profile.free-event": "Free",
	"profile.get-tickets": "Get tickets",
	"profile.is-private": "This profile is private.",
	"profile.live-widget": "Like this widget?",
	"profile.message-user": "Message",
	"profile.more-time-slots": "{formattedDate} + {moreTimeSlotCount, number} more",
	"profile.no-upcoming-events": "{name} doesn't have any upcoming events.",
	"profile.owner-no-upcoming-events": "You don't have any upcoming events.",
	"profile.past-events": "Past events",
	"profile.powered-by": "Powered by",
	"profile.upcoming-events": "Upcoming events",
	"profile.use-this-space": "Use this space to promote your events! (max 2MB)",
	"profile.viewing-own-private-profile": "Your profile is set to private. Only you can see the information on this page.",
	"profile.virtualEvent": "Virtual event",
	"questionnaire.continue": "Continue",
	"questionnaire.freeEvent": "Free",
	"questionnaire.howManyAttendees": "How many attendees are you expecting?",
	"questionnaire.isYourEventPaid": "Is your event free or paid?",
	"questionnaire.largeHost": "1000+",
	"questionnaire.mediumHost": "100 - 1000",
	"questionnaire.paidEvent": "Paid",
	"questionnaire.smallHost": "1 - 100",
	"questionnaire.subtitle": "Let's make your event happen.",
	"questionnaire.title": "Hey {name}!",
	"quickReports.accountActivityDescription": "All the money that came into and out of your account including: ticket sales, ticket purchases, withdrawals, and Chargebacks.",
	"quickReports.accountActivityTitle": "Account Activity",
	"quickReports.cancellationsDescription": "All refunded tickets for your events.",
	"quickReports.cancellationsTitle": "Cancellations",
	"quickReports.ordersDescription": "Data on each attendee including a cost breakdown of each ticket.",
	"quickReports.ordersTitle": "Orders",
	"quickReports.ticketDateTimeDescription": "A summary report of sales per ticket type per timeslot on an event page.",
	"quickReports.ticketDateTimeTitle": "Ticket Type - Timeslot Level",
	"quickReports.ticketEventDescription": "A cost breakdown of each ticket.",
	"quickReports.ticketEventTitle": "Ticket Type - Event Level",
	"quickReports.ticketsDescription": "Data on all buyers including a cost breakdown of each order.",
	"quickReports.ticketsTitle": "Tickets",
	"reports.content.actions": "Actions",
	"reports.content.date": "Date created",
	"reports.content.description": "Description",
	"reports.content.noDescription": "No description",
	"reports.content.report": "Report",
	"reports.content.type": "Type",
	"reports.createCustomReportsBtn": "Create a custom report",
	"reports.custom-events.all-events": "All events",
	"reports.custom-events.allCurrency": "All currency",
	"reports.custom-events.cancel": "Cancel",
	"reports.custom-events.date": "Event Date",
	"reports.custom-events.event-name": "Event name",
	"reports.custom-events.expired": "Expired",
	"reports.custom-events.filter-events": "{count, plural, one {Select {count} event} other {Select {count} events}}",
	"reports.custom-events.live": "Live",
	"reports.custom-events.num-selected-events": "{count, plural, one {{count} event selected} other {{count} events selected}}",
	"reports.custom-events.select-all-events": "Select all events",
	"reports.custom-events.selectEvents": "Select events",
	"reports.custom-events.selected-events": "Selected events",
	"reports.custom-events.sort": "Sort",
	"reports.custom-events.status": "Status",
	"reports.custom-reports.selectStatus": "Select status",
	"reports.custom-reports.sort-by-buyer-first-name": "Buyer's First Name",
	"reports.custom-reports.sort-by-buyer-last-name": "Buyer's Last Name",
	"reports.custom-reports.sort-by-date-ascending": "Oldest to Newest Date of Order",
	"reports.custom-reports.sort-by-date-descending": "Newest to Oldest Date of Order",
	"reports.custom-reports.sort-by-first-name": "First Name",
	"reports.custom-reports.sort-by-last-name": "Last Name",
	"reports.custom.addDescription": "Description (optional)",
	"reports.custom.addFilters": "Add filters",
	"reports.custom.afterSpecificDay": "After a specific day...",
	"reports.custom.afterSpecificDayDisp": "After {date}",
	"reports.custom.all": "All",
	"reports.custom.allDates": "All dates",
	"reports.custom.allPaymentStates": "All states",
	"reports.custom.alphabetically": "Alphabetically",
	"reports.custom.backToReports": "Back to reports",
	"reports.custom.beforeSpecificDay": "Before a specific day...",
	"reports.custom.beforeSpecificDayDisp": "Before {date}",
	"reports.custom.byFirstName": "By first name",
	"reports.custom.byLastName": "By last name",
	"reports.custom.byNewest": "By newest",
	"reports.custom.cancel.are-you-sure": "Are you sure you want to cancel these changes to your custom report? By clicking Cancel changes, all changes entered will not be saved.",
	"reports.custom.cancel.cancel": "Cancel",
	"reports.custom.cancel.cancel-changes": "Cancel changes",
	"reports.custom.cancel.cannot-be-undone": "This action cannot be undone.",
	"reports.custom.cancel.confirm": "Confirm",
	"reports.custom.cancel.contentLabel": "Confirm cancel custom report creation",
	"reports.custom.cancel.keepChanges": "Keep changes",
	"reports.custom.cancel.title": "Confirm Cancellation",
	"reports.custom.cancelled": "Cancelled",
	"reports.custom.closed": "Closed",
	"reports.custom.confirm.cancel": "Cancel",
	"reports.custom.confirm.confirm": "Yes, continue",
	"reports.custom.confirm.confirmButtonLabel": "Yes, continue",
	"reports.custom.confirm.confirmModalTitle": "Create Report",
	"reports.custom.confirm.confirmModalTitleWithExternalRecipients": "Confirm recipients",
	"reports.custom.confirm.confirmWithExternalRecipients": "Confirm",
	"reports.custom.confirm.confirmWithExternalRecipientsButtonLabel": "Confirm",
	"reports.custom.confirm.contentLabel": "Confirm custom report creation",
	"reports.custom.confirm.ensure": "The following <b>external recipient</b> emails will be sent this scheduled report. <br>Please ensure their emails have been typed correctly:",
	"reports.custom.confirm.title": "Create Report",
	"reports.custom.confirm.titleWithExternalRecipients": "Confirm recipients",
	"reports.custom.confirm.understand": "I understand that each selected <b>Team member</b> will get this report in it's entirety regardless of team member event permissions.",
	"reports.custom.createBtn": "Create report",
	"reports.custom.createEdit": "Edit custom report",
	"reports.custom.createSubtitle": "Create and customize a report to get the insights you need to inform your business decisions.",
	"reports.custom.createTitle": "Create custom report",
	"reports.custom.customDateRange": "Date range",
	"reports.custom.customDateRangeDisp": "{start} - {end}",
	"reports.custom.dashboard": "Dashboard",
	"reports.custom.dateAttending": "Date attending",
	"reports.custom.dateOfOrder": "Date of order",
	"reports.custom.declined": "Declined",
	"reports.custom.delete": "Delete report",
	"reports.custom.edit": "Edit",
	"reports.custom.editSubtitle": "Customize your report to get the insights you need to inform your business decisions.",
	"reports.custom.empty": "Get access to the insights you need ー select your data points, apply filters, and schedule a report.",
	"reports.custom.ended": "Ended",
	"reports.custom.error": "Error",
	"reports.custom.errorColumnsDescription": "You must select at least 1 column to build a report",
	"reports.custom.errorFileExtensionRequired": "A file extension is required.",
	"reports.custom.errorReportNameRequired": "Report name is required.",
	"reports.custom.errorReportTypeRequired": "Report type is required.",
	"reports.custom.expired": "Expired",
	"reports.custom.externalRecipient": "External recipients",
	"reports.custom.externalRecipientPlaceholder": "Enter email addresses",
	"reports.custom.facebook": "Facebook",
	"reports.custom.failed": "Failed",
	"reports.custom.greaterThan": "Greater than",
	"reports.custom.lessThan": "Less than",
	"reports.custom.noResults": "Your search returned no results...",
	"reports.custom.onSpecificDay": "On a specific day...",
	"reports.custom.paid": "Paid",
	"reports.custom.partiallyPaid": "Partially Paid",
	"reports.custom.pastDay": "Past 24 hours",
	"reports.custom.pastSevenDays": "Past 7 days",
	"reports.custom.pastThirtyDays": "Past 30 days",
	"reports.custom.paymentStatus": "Payment status",
	"reports.custom.paymentStatusError": "Payment status is required.",
	"reports.custom.pending": "Pending",
	"reports.custom.processing": "Processing",
	"reports.custom.purchaseSource": "Purchase source",
	"reports.custom.reportInformation": "Report information",
	"reports.custom.reportName": "Report name",
	"reports.custom.reportType": "Report type",
	"reports.custom.reportType.addOnsReport": "Add-ons Report",
	"reports.custom.reportType.attendeesReport": "Attendees Report",
	"reports.custom.reportType.ordersReport": "Orders Report",
	"reports.custom.reportType.ticketsReport": "Tickets Report",
	"reports.custom.saveBtn": "Save custom report",
	"reports.custom.saveDateCustomReport": "Save",
	"reports.custom.scheduler.DateRange": "Date range",
	"reports.custom.scheduler.Warning": "If all events are in the past, this report will no longer send.",
	"reports.custom.scheduler.confirm": "Confirm",
	"reports.custom.scheduler.daily": "Daily",
	"reports.custom.scheduler.disableScheduler": "Disable schedule",
	"reports.custom.scheduler.emailedTo": "This report will be emailed to",
	"reports.custom.scheduler.frequency": "Frequency",
	"reports.custom.scheduler.friday": "Friday",
	"reports.custom.scheduler.monday": "Monday",
	"reports.custom.scheduler.saturday": "Saturday",
	"reports.custom.scheduler.schedule": "Schedule",
	"reports.custom.scheduler.scheduleReport": "Schedule this report",
	"reports.custom.scheduler.selectDay": "Select day",
	"reports.custom.scheduler.selectHour": "Select time",
	"reports.custom.scheduler.sunday": "Sunday",
	"reports.custom.scheduler.thursday": "Thursday",
	"reports.custom.scheduler.tuesday": "Tuesday",
	"reports.custom.scheduler.wednesday": "Wednesday",
	"reports.custom.scheduler.weekly": "Weekly",
	"reports.custom.searchBar": "Search for a report",
	"reports.custom.selectAllColumns": "Select All",
	"reports.custom.setupDescription": "Select events to appear in report",
	"reports.custom.setupReport": "Setup report",
	"reports.custom.showColumns": "Show columns",
	"reports.custom.showColumnsDescription": "Select at least 1 column to build a report",
	"reports.custom.showLessOptions": "Show less",
	"reports.custom.showMoreOptions": "Show more",
	"reports.custom.sortBy": "Sort by",
	"reports.custom.teamMemberEmails": "Team member emails",
	"reports.custom.teamMemberEmailsPlaceholder": "Select...",
	"reports.custom.title": "Custom Reports",
	"reports.custom.transferred": "Transferred",
	"reports.custom.unapproved": "Unapproved",
	"reports.custom.unauthorized": "Unauthorized",
	"reports.custom.unpaid": "Unpaid",
	"reports.custom.upgraded": "Upgraded",
	"reports.custom.waitlistReportTooltip": "Add your own privacy policy via your Account Settings to begin collecting a marketing list.",
	"reports.customReportsTitle": "Custom reports",
	"reports.description": "On this page you'll be able to download your account level reports.",
	"reports.descriptionBlocked": "You'll be able to download your account level reports from this page once you've sold tickets or add-ons.",
	"reports.download": "Download",
	"reports.legacy.reports": "Legacy Reports",
	"reports.modal.attractionTitle": "Attraction",
	"reports.modal.breakdownTypeTitle": "Breakdown type",
	"reports.modal.cancelBtn": "Cancel",
	"reports.modal.currencyTitle": "Currency",
	"reports.modal.dateCurrencyPickerTitle": "Select a date range and currency for your {reportTitle}",
	"reports.modal.dateAccountsPickerTitle": "Select a date range and accounts for your {reportTitle}",
	"reports.modal.dateCurrencyAccountsPickerTitle": "Select a date range, currency and accounts for your {reportTitle}",
	"reports.modal.datePickerTitle": "Select a date range for your {reportTitle}",
	"reports.modal.deleteBtn": "Delete custom report",
	"reports.modal.downloadReport": "Download Report",
	"reports.modal.extendedAuditReport": "Include net sales breakdown",
	"reports.modal.itemizedReport": "Itemized report",
	"reports.modal.largeEmailButton": "Ok got it!",
	"reports.modal.largeEmailInfo": "Due to the size of this report it will be sent via email to {email}. Please allow 5-10 minutes for the report to generate and send.",
	"reports.modal.largeEmailTitle": "Your report is on the way",
	"reports.modal.largeReportInfo": "Excel files greater than 1 million rows may not be able to open. We recommend downloading a CSV file or selecting a smaller date range.",
	"reports.modal.noDataInfo": "There is not enough data to populate this report. This report will be available once there are transactions in your account.",
	"reports.modal.summaryReport": "Summary report",
	"reports.modal.timeRangeTitle": "Date range",
	"reports.modal.multiAccountTitle": "Accounts",
	"reports.modal.warning": "Are you sure you want to delete this report? This action cannot be undone.",
	"reports.movedWarning": "This report has moved!",
	"reports.options.filterBy.allTransactions": "All Transactions",
	"reports.options.filterBy.customDateRange": "Custom Date Range",
	"reports.options.filterBy.past30Days": "Past 30 Days",
	"reports.options.filterBy.past7Days": "Past 7 Days",
	"reports.options.filterBy.singleDay": "Single Day",
	"reports.quick.accountActivity": "Account Activity",
	"reports.quick.accountActivityDescription": "All the money that came into and out of your account including, ticket sales, ticket purchases, withdrawals, and chargebacks. This report is updated every 24 hours.",
	"reports.quick.addOnsDescription": "Data on each attendee including a cost breakdown of each add-on.",
	"reports.quick.addons": "Add-ons",
	"reports.quick.attractionDateRangeTitle": "Date attending",
	"reports.quick.boxOffice": "Box office",
	"reports.quick.boxOfficeDescription": "Summary report that shows on-site sales by cashier, payment method and event.",
	"reports.quick.cancellations": "Cancellations",
	"reports.quick.cancellationsDescription": "All refunded tickets for your events.",
	"reports.quick.orders": "Orders",
	"reports.quick.ordersDescription": "Data on all buyers including a cost breakdown of each order.",
	"reports.quick.payoutSettlement": "Payout settlement",
	"reports.quick.payoutSettlementDescription": "Summary report of the money released to you by Universe including ticket sales, refunds, chargebacks and withdrawals.",
	"reports.quick.quickAttraction": "Attraction",
	"reports.quick.quickAttractionDescription": "Summary report that shows performance for selected attraction by time period.",
	"reports.quick.quickAudit": "Audit",
	"reports.quick.quickAuditDescription": "Summary report of your ticket sales across all events.",
	"reports.quick.quickChargeback": "Chargebacks",
	"reports.quick.quickChargebackDescription": "All disputed charges on your account for payments processed using Universe Payments.",
	"reports.quick.quickDownloadDisabledDescription": "Provide your privacy policy to enable this list.",
	"reports.quick.quickRebate": "Rebates",
	"reports.quick.quickRebateDescription": "A summary of funds received from rebates.",
	"reports.quick.quickSettlement": "Settlements",
	"reports.quick.quickSettlementDescription": "A summary report that shows a cost breakdown for each event, including net sales and tickets sold. (Looking for a breakdown of paid/free tickets and add-ons? Check out our new Sales by Event report!)",
	"reports.quick.quickTicketTimeslotChangesMovedInfo": "It can now be downloaded from the Reports page found in Event Manager.",
	"reports.quick.quickWaitlist": "Marketing List",
	"reports.quick.quickWaitlistDescription": "A list of fans interested in staying up to date with your events.",
	"reports.quick.selectDateRangeAndDownload.": "Select Date Range",
	"reports.quick.ticketDatetimeLevel": "Ticket Type - Timeslot Level",
	"reports.quick.ticketDatetimeLevelDescription": "A summary report of the number of tickets sold per ticket type per timeslot on each event page.",
	"reports.quick.ticketEventLevel": "Ticket Type - Event Level",
	"reports.quick.ticketEventLevelDescription": "A summary report of the number of tickets sold per ticket type per event page.",
	"reports.quick.ticketTimeslotChanges": "Timeslot Changes",
	"reports.quick.ticketTimeslotChangesDescription": "A reference report detailing programmed price and quantity per ticket type per timeslot on each event page",
	"reports.quick.tickets": "Tickets",
	"reports.quick.ticketsDescription": "Data on each attendee including a cost breakdown of each ticket.",
	"reports.quick.title": "Quick Reports",
	"reports.quickReportsTitle": "Quick reports",
	"reports.reportDownloadError": "There was an error downloading this report",
	"reports.salesByEvent": "Sales by Event",
	"reports.salesByEventDescription": "A summary report that shows a sales breakdown for each event, including paid tickets, free tickets, and add-ons.",
	"reports.subTitle": "Reports",
	"reports.timeslotChangesReportAlert": "The Timeslot Changes Report has moved!",
	"reports.timeslotChangesReportAlertDescription": "This report has moved from this page to the Reports page in the Event Manager.",
	"reports.title": "Reports",
	"routes.listing.event-disclosure": "Event disclosure information",
	"tickets.capacity": "Capacity",
	"tickets.displayCurrency": "Display currency",
	"tickets.nameError": "Ticket name is required",
	"tickets.paymentInfo": "To keep things simple, your transactions will be handled by our in-house payment processor. You can learn more about payment options or change processors in the Event Manager after your event is created.",
	"tickets.paymentPreferences": "Your payment preferences",
	"tickets.price": "Price",
	"tickets.priceError": "Ticket price is required",
	"tickets.publishButtonText": "Publish my event",
	"tickets.saveAndPublishLaterButtonText": "Save and publish later",
	"tickets.selectCurrency": "Select a currency",
	"tickets.ticketName": "Name your ticket type",
	"tickets.ticketNameDefault": "General Admission",
	"tickets.ticketTips": "You can add additional ticket types in the Event Manager once your event is created.",
	"tickets.title": "Your event is almost ready! Just one last detail...",
	"tickets.transactedCurrency": "Transacted currency",
	"tickets.unlimited": "Unlimited",
	"view-order.addOn": "Add-on",
	"view-order.addOnDescription": "Description",
	"view-order.addOnOption": "Option",
	"view-order.addOnPurchaseMessageHeader": "Add-on message",
	"view-order.addOns": "Add-ons",
	"view-order.amountRefunded": "Amount refunded",
	"view-order.at": "at",
	"view-order.bankInfo": "Your bank account with {bankName}, was charged {amount} on {date}",
	"view-order.cancelOrder": "Cancel order",
	"view-order.cancelOrderText": "Please cancel my ticket",
	"view-order.changeDate": "Change date",
	"view-order.chargeInfo": "Your credit card was charged {amount} on {date}.",
	"view-order.contactHost": "Contact host",
	"view-order.dateChangeLimit.Never": "Date changes are not allowed for this order.",
	"view-order.dateChangeLimit.OneDay": "Date changes accepted upto 1 day before the start of the event.",
	"view-order.dateChangeLimit.OneHour": "Date changes accepted upto 1 hour before the start of the event.",
	"view-order.dateChangeLimit.OneWeek": "Date changes accepted upto 1 week before the start of the event.",
	"view-order.dateChangeLimit.ThreeDays": "Date changes accepted upto 3 days before the start of the event.",
	"view-order.dateChangeLimit.TwoDays": "Date changes accepted upto 2 days before the start of the event.",
	"view-order.dateChangeLimit.UntilEventStart": "Date changes accepted until the start of the event.",
	"view-order.discountApplied": "Discount applied {code}",
	"view-order.downloadAddOn": "Download add-on",
	"view-order.downloadOrder": "Download order",
	"view-order.downloadTicket": "Download ticket",
	"view-order.editTicket": "Edit ticket",
	"view-order.fees": "Fees",
	"view-order.free": "FREE",
	"view-order.generateInvoice": "Generate invoice",
	"view-order.globeeInfo": "Your {providerSourceType} account was charged {amount} on {date}.",
	"view-order.go-back": "< Go back",
	"view-order.idealInfo": "Your iDEAL account ending in {lastDigits} was charged {amount} on {date}.",
	"view-order.klarnaCancelInfo": "{amount} has been refunded to your Klarna account on {date}. For more details <a target='_blank' href='https://app.klarna.com/login'>log in to your Klarna account</a>",
	"view-order.klarnaInfo": "Your Klarna account was charged {amount}. For more details <a target='_blank' href='https://app.klarna.com/login'>log in to your Klarna account</a>",
	"view-order.latestTicketType": "Latest Ticket Type",
	"view-order.learn-more": "Learn More",
	"view-order.menu": "Menu",
	"view-order.more-actions": "More actions",
	"view-order.multibancoInfo": "Your Multibanco reference ending in {lastDigits} was charged {amount} on {date}",
	"view-order.name": "Name",
	"view-order.orderCancelled": "This order has been cancelled.",
	"view-order.orderProtectCharge": "Order Protection",
	"view-order.orderUpdated": "Order updated",
	"view-order.paymentInfo": "Your card ending in {lastDigits} was charged {amount} on {date}.",
	"view-order.paymentPlanFee": "One-time Payment Plan Fee",
	"view-order.paypalInfo": "Your PayPal account has been charged",
	"view-order.perOrderFeeCharge": "Per Order Fee",
	"view-order.purchasedBy": "Purchased by",
	"view-order.qrCode-invoiceUnapprovedTicketQRCode": "Your tickets will be released once the host receives and approves your payment",
	"view-order.qrCode-neverUnreleasedQRCode": "Confirmed!",
	"view-order.qrCode-paymentPlanUnreleasedQRCode": "Your tickets will be released once the payment plan has been paid in full",
	"view-order.qrCode-sofortPendingTicketQRCode": "Your tickets will be released once we’ve received your SOFORT payment",
	"view-order.qrCode-unauthorizedTicketQRCode": "Your tickets will be released once the order has been authorized",
	"view-order.qrCode-unpaid": "These tickets will be released when the payment is received",
	"view-order.qrCode-unreleased": "This ticket will be released {count} {count, plural, =0 {day} one {day} other {days}} prior to the event",
	"view-order.quantity": "Quantity",
	"view-order.receipt": "Payment Information",
	"view-order.refund": "Refund Information",
	"view-order.refundPaymentInfo": "Your card ending in {lastDigits} was refunded {amount} on {date}.",
	"view-order.refundPolicyEvent": "{days, plural, one {Refunds will be accepted up to {days} day before the start of the event.} other {Refunds will be accepted up to {days} days before the start of the event.}}",
	"view-order.refundPolicyHeader": "Refund & changes:",
	"view-order.refundPolicyNone": "This order is non-refundable.",
	"view-order.refundPolicyPurchase": "{days, plural, one {Refunds will be accepted up to {days} day from the purchase date.} other {Refunds will be accepted up to {days} days from the purchase date.}}",
	"view-order.refundPolicyTypeEvent": "before the start of the event.",
	"view-order.refundPolicyTypePurchase": "from the purchase date.",
	"view-order.refundTotal": "Refund Total",
	"view-order.refund_total": "Amount Refunded",
	"view-order.refundedInfo": "{amount} has been refunded to card ending in {lastDigits} on {date}.",
	"view-order.refundedReceipt": "Refund receipt",
	"view-order.refundedReceiptWithDate": "Refund ({date})",
	"view-order.seatsBooth": "Booth",
	"view-order.seatsGeneralAdmission": "General Admission",
	"view-order.seatsRow": "Row",
	"view-order.seatsSeat": "Seat",
	"view-order.seatsSection": "Section",
	"view-order.seatsTable": "Table",
	"view-order.sepaInfo": "Your IBAN ending in {lastDigits} was charged {amount} on {date}.",
	"view-order.serviceCharge": "Service Charge",
	"view-order.serviceChargeTooltipFees": "Service fees are shared between parties that help make the event happen. This commonly includes venues, promoters, operators, producers and Universe.",
	"view-order.serviceChargeTooltipNoFees": "Service fees help Universe cover the operating costs needed to provide fans with a safe and secure ticket-buying experience.",
	"view-order.sofortInfo": "Your SOFORT account has been charged",
	"view-order.subheading": "Review and manage your order, including downloading, transferring and editing your tickets.",
	"view-order.subheading-1": "Review and manage your order, including downloading, transferring and editing your tickets.",
	"view-order.submitClaim": "Request a refund",
	"view-order.subtotal": "Subtotal",
	"view-order.tax": "Tax",
	"view-order.tax-info": "City, state and local taxes as applicable",
	"view-order.taxes": "Taxes",
	"view-order.ticketCancelled": "This ticket has been cancelled.",
	"view-order.ticketDeclined": "This ticket has been declined.",
	"view-order.ticketErorr": "This ticket is not valid for entry.",
	"view-order.ticketFailed": "This ticket has failed.",
	"view-order.ticketHistory": "Ticket History",
	"view-order.ticketType": "Ticket type",
	"view-order.ticketUpgraded": "This ticket has been upgraded.",
	"view-order.total": "Total",
	"view-order.total_by_invoice": "Total (Pay by invoice)",
	"view-order.transferTicket": "Transfer Ticket",
	"view-order.unitPrice": "Unit Price",
	"view-order.updatedReceipt": "Refund Information - {ticketId}",
	"view-order.updated_total": "Updated total",
	"view-order.upgradeDate": "Upgrade Date",
	"view-order.upgradeHistory": "Upgrade History",
	"view-order.viewLatestTicket": "View latest ticket",
	"view-order.viewOrder": "View order",
	"view-order.viewPDFOrder": "View Order PDF",
	"view-order.viewPDFTicket": "View Ticket PDF",
	"view-order.yourOrder": "Your order",
	"view-order.yourReceipt": "Your Receipt",
	"view-ticket.go-back": "< Go back",
	"view-ticket.myAddOn": "My add-on",
	"view-ticket.yourTicket": "Your ticket",
	"viewOrder.yourTickets": "Your Tickets",
	"whenwhere.dateEndText": "End",
	"whenwhere.dateEndTitle": "End",
	"whenwhere.dateStartText": "Start",
	"whenwhere.dateStartTitle": "Start",
	"whenwhere.datesSubText": "Need more event times? You can add them later in the Event Manager.",
	"whenwhere.locationText": "Event location",
	"whenwhere.locationTitle": "Event location",
	"whenwhere.ticketButton": "Ticket details",
	"whenwhere.title": "Choose a time and place for your event",
	"withdrawals.description": "Once your request is approved, you'll receive an email to activate your Universe Payouts account. If you already have a Universe Payouts account please log in to transfer your money. Funds can be sent via Direct Deposit, PayPal, Check (US only) or Wire Transfer (available for select currencies). To transfer your funds via PayPal, the email address on your Universe Payouts account must match the email address on the PayPal account you are transferring your funds to. Learn more about how Universe Payouts work.",
	"withdrawals.form.address": "Address",
	"withdrawals.form.addressRequired": "Address is a required field",
	"withdrawals.form.birthday": "Date of Birth",
	"withdrawals.form.birthdayRequired": "Date of Birth is a required field",
	"withdrawals.form.city": "City",
	"withdrawals.form.cityRequired": "City is a required field",
	"withdrawals.form.confirmEmail": "Confirm Email",
	"withdrawals.form.confirmEmailRequired": "Please confirm your email",
	"withdrawals.form.contactInformationDescription": "This information will be used to activate your Universe Payouts account",
	"withdrawals.form.contactInformationTitle": "Contact information",
	"withdrawals.form.country": "Country",
	"withdrawals.form.countryRequired": "Country is a required field",
	"withdrawals.form.currency.infoBlock": "You can withdraw between {minAmount} and {maxAmount}",
	"withdrawals.form.email": "Email",
	"withdrawals.form.emailMismatch": "Emails must match",
	"withdrawals.form.emailMismatchTooltip": "Use the same email for each withdrawal to ensure funds go to the same Universe Payouts account. A different email may require setting up a new account with ID and bank verification.",
	"withdrawals.form.emailMismatchWarning": "Email does not match previous withdrawal",
	"withdrawals.form.emailRequired": "Email is required",
	"withdrawals.form.enterAmountTitle": "Enter amount you'd like to request",
	"withdrawals.form.firstName": "First Name",
	"withdrawals.form.firstNameRequired": "First Name is a required field",
	"withdrawals.form.invalidEmail": "Invalid email address",
	"withdrawals.form.lastName": "Last Name",
	"withdrawals.form.lastNameRequired": "Last Name is a required field",
	"withdrawals.form.phone": "Phone",
	"withdrawals.form.phoneRequired": "Phone Number is a required field",
	"withdrawals.form.postalCode": "ZIP / Postal Code",
	"withdrawals.form.postalCodeRequired": "ZIP / Postal Code is a required field",
	"withdrawals.form.province": "State / Province",
	"withdrawals.form.provinceRequired": "State / Province is a required field",
	"withdrawals.form.requestedAmount": "Requested Amount",
	"withdrawals.form.requestedAmountDecimal": "Requested Amount must have at most 2 decimal places",
	"withdrawals.form.requestedAmountMax": "Requested Amount must not exceed withdrawable balance",
	"withdrawals.form.requestedAmountRequired": "Requested Amount is a required field",
	"withdrawals.modal.confirm.amount": "Amount",
	"withdrawals.modal.confirm.birthday": "Date of Birth",
	"withdrawals.modal.confirm.cancel": "Cancel",
	"withdrawals.modal.confirm.confirm": "Confirm",
	"withdrawals.modal.confirm.country": "Country",
	"withdrawals.modal.confirm.description": "Before you submit your withdrawal please confirm that this information is correct as this action cannot be undone once you confirm.",
	"withdrawals.modal.confirm.email": "Email",
	"withdrawals.modal.confirm.fullName": "Full Name",
	"withdrawals.modal.confirm.phoneNumber": "Phone Number",
	"withdrawals.modal.confirm.title": "Confirm request",
	"withdrawals.modal.error.contactSupport": "Please contact support if you need further assistance.",
	"withdrawals.modal.error.description": "There was an error handling your request:",
	"withdrawals.modal.error.goBack": "Go back",
	"withdrawals.modal.sent.description": "You can expect an email within 1-2 business days with next steps on how to activate your Universe Payouts account. In the meantime, you can {link}.",
	"withdrawals.modal.sent.learnMore": "learn more about how payouts work",
	"withdrawals.modal.sent.okay": "Okay got it!",
	"withdrawals.modal.sent.title": "Sit tight - we're reviewing your request.",
	"withdrawals.steps.activateUniversePayouts": "Activate Universe Payouts",
	"withdrawals.steps.requestFunds": "Request Funds",
	"withdrawals.steps.step1": "step 1",
	"withdrawals.steps.step2": "step 2",
	"withdrawals.steps.step3": "step 3",
	"withdrawals.steps.step4": "step 4",
	"withdrawals.steps.transferFunds": "Transfer your Funds",
	"withdrawals.steps.waitForApproval": "Wait for Approval",
	"withdrawals.title": "Request your funds"
};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ })

});


// WEBPACK FOOTER //
// enterprise-assets/35.25597ca8.chunk.js